import React from 'react';

import { H2Styled } from './H2.style';

export const H2 = ({ children, ...props }: { children: any }) => {
  return <H2Styled {...props}>{children}</H2Styled>;
};
